import React from 'react';

export const Button: React.FC<{
  label: string;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}> = (props) => {
  return (
    <button
      style={{
        background: props.disabled ? '#d3d3d3' : 'var(--c-button-background)',
        color: props.disabled ? '#5C5C5C' : 'var(--c-button-text)',
        cursor: props.disabled ? 'not-allowed' : 'pointer',
      }}
      className={
        'rounded-[300px] ' +
        'min-w-[120px] ' +
        'px-5 ' +
        'py-4 ' +
        'font-bold ' +
        'focus:outline-none ' +
        'focus:ring-2 ' +
        (props.disabled ? '' : 'focus:ring-[--c-primary-color] ') +
        (props.className || '')
      }
      onClick={props.disabled ? undefined : props.onClick}
      onMouseEnter={(e) => {
        if (!props.disabled) {
          e.currentTarget.style.background = 'var(--c-button-background-hover)';
        }
      }}
      onMouseLeave={(e) => {
        if (!props.disabled) {
          e.currentTarget.style.background = 'var(--c-button-background)';
        }
      }}
      type={props.type ?? 'button'}
      title={props.label}
      disabled={props.disabled}
    >
      {props.label}
    </button>
  );
};
